import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { FetchPromoCodesResponse, FetchPromoCodeUsagesResponse } from '../../../types/promoCodes';
import { fetchPromoCodes, fetchPromoCodeUsages, updatePromoCode } from './promoCode.actions';
import { PromoCodeState } from './promoCode.types';

const initialState: PromoCodeState = {
  promoCodes: [],
  promoCodeUsages: [],
  totalPromoCodes: 0,
  totalPromoCodeUsages: 0,
  editPromoCode: null,
  fetchStatus: fetchStatuses.idle,
  updateStatus: fetchStatuses.idle,
  updateDefaultStatus: fetchStatuses.idle,
  createStatus: fetchStatuses.idle,
  error: null,
};

const promoCodesSlice = createSlice({
  name: 'promoCodes',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchPromoCodes.pending, (state) => {
      state.fetchStatus = fetchStatuses.pending;
      state.updateStatus = fetchStatuses.idle;
      state.createStatus = fetchStatuses.idle;
    });
    builder.addCase(fetchPromoCodes.fulfilled, (state, action: PayloadAction<FetchPromoCodesResponse>) => {
      state.promoCodes = action.payload.data?.items;
      state.totalPromoCodes = action.payload.data?.totalItems;
      state.fetchStatus = fetchStatuses.success;
    });
    builder.addCase(fetchPromoCodes.rejected, (state, action) => {
      state.fetchStatus = fetchStatuses.rejected;
      state.error = action.error;
    });

    builder.addCase(updatePromoCode.pending, (state) => {
      state.updateStatus = fetchStatuses.pending;
      state.fetchStatus = fetchStatuses.idle;
      state.createStatus = fetchStatuses.idle;
    });
    builder.addCase(updatePromoCode.fulfilled, (state) => {
      state.fetchStatus = fetchStatuses.success;
    });
    builder.addCase(updatePromoCode.rejected, (state, action) => {
      state.fetchStatus = fetchStatuses.rejected;
      state.error = action.error;
    });

    builder.addCase(fetchPromoCodeUsages.pending, (state) => {
      state.fetchStatus = fetchStatuses.pending;
    });
    builder.addCase(fetchPromoCodeUsages.fulfilled, (state, action: PayloadAction<FetchPromoCodeUsagesResponse>) => {
      state.promoCodeUsages = action.payload.data?.items;
      state.totalPromoCodeUsages = action.payload.data?.totalItems;
      state.fetchStatus = fetchStatuses.success;
    });
    builder.addCase(fetchPromoCodeUsages.rejected, (state, action) => {
      state.fetchStatus = fetchStatuses.rejected;
      state.error = action.error;
    });
  },
});

export const promoCodesReducer = promoCodesSlice.reducer;
